import * as React from 'react'
import { ReactElement } from 'react'
import { Formik, useFormikContext } from 'formik'
import FormContainer from '../../../../components/Form/FormContainer'
import { FileMutationDto } from '../../../../config/fileConfig'
import { SurchargeDialogProps } from './FileSurchargeDialog'
import FileSurchargeFormContainer from './FileSurchargeFormContainer'
import { FileSurchargeDto } from './FileSurchargeList'

export type SurchargeFormProps = SurchargeDialogProps & {
    onSubmit: any
}

export default function FileSurchargeForm(props: SurchargeFormProps): ReactElement {
    const fileContext = useFormikContext<FileMutationDto>()

    return (
        <Formik<FileSurchargeDto> initialValues={props.initialValues} onSubmit={props.onSubmit}>
            <FormContainer>
                <FileSurchargeFormContainer fileContext={fileContext} {...props} />
            </FormContainer>
        </Formik>
    )
}
